import * as React from 'react';

export interface WithGlobalLoadingProps {
  globalLoading: boolean;
  setGlobalLoading: (value: boolean) => void;
}

const defaultValue: WithGlobalLoadingProps = {
  globalLoading: false,
  setGlobalLoading: () => false,
};

const context = React.createContext(defaultValue);
export default context;
